export default __webpack_public_path__ + "1f90658be8d48c5ec9ba10862eed1984.svg";